import React, { useRef } from "react";
import { CSVLink } from "react-csv";
import "../buttons/CustomizButton.css";

const CustomizButton = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  icon = null,
  iconPosition = "left",
  style = {},
  width,
  csvButton = false,
  csvListData = [],
  filename = "download.csv",
}) => {
  const btnRef = useRef(null);

  const buttonContent = (
    <>
      {iconPosition === "left" && icon && <>{icon}</>}
      {label}
      {iconPosition === "right" && icon && <>{icon}</>}
    </>
  );

  const buttonStyles = {
    width: width || "",
    ...style,
  };

  if (csvButton) {
    return (
      <CSVLink
        data={csvListData}
        filename={filename}
        className={`customButton body-highlight ${variant} ${className} d-flex align-items-center justify-content-center gap-2`}
        ref={btnRef}
        style={{ textDecoration: "none" }}
      >
        {buttonContent}
      </CSVLink>
    );
  }

  return (
    <button
      ref={btnRef}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`customButton body-highlight ${variant} ${className} d-flex align-items-center justify-content-center gap-2`}
      style={buttonStyles}
    >
      {buttonContent}
    </button>
  );
};

export default CustomizButton;
